import React from "react"
import { Skeleton } from "@mui/material"
import { DatePickerSeeker } from "@ui-seeker/core"

import { errors, loadingDate, singleDate } from "@signals"


export default function AppCommonFiltersSingleDatePicker({ ...props }) {

	if (loadingDate.value) return <Skeleton style={{ height: '100%' }}/>

	return <DatePickerSeeker
		label="Select Date"
		value={singleDate.value}
		error={errors.value?.singleDate}
		onChange={e => singleDate.value = e}
		{...props}
	/>
}